import React from 'react'
import actionTarget from '../Redux/actionTarget'
import { formFieldsValue } from './action'

export class FormReducer extends React.Component {

    componentDidMount() {
        const {
            didMount
        } = this.props
        if (didMount) {
            didMount()
        }
    }

    componentDidUpdate(prevProps, _prevState) {
        const {
            dispatch,
            storeTarget,
            onDataChanged,
            onDataChangedContext,
            submit,
            action,
            data
        } = this.props
        if (prevProps.data !== data) {
            if (onDataChanged) {
                const postAction = onDataChanged(data, onDataChangedContext)
                if (postAction) {
                    dispatch(actionTarget(postAction, storeTarget))
                }
            }
        }
        if (prevProps.submit !== submit && submit && action) {
            // Check type of action, function, object, string, etc...
            dispatch(actionTarget(formFieldsValue(action), storeTarget))
        }
    }

    render() {
        const {
            children
        } = this.props
        return children ? React.Children.only(children) : null
    }
}
